// After a publish, an app left open (or restored from the background) keeps running the old version.
// On open and whenever it comes back to the foreground, compare the published bundle with the running one; reload if new.
const bundleOf = (html) => (html.match(/\/static\/js\/main\.[\w]+\.js/) || [])[0];

const running = () => {
  const s = Array.from(document.scripts).map((x) => x.src).find((src) => /\/static\/js\/main\.[\w]+\.js/.test(src));
  return s ? bundleOf(s) : null;
};

const check = async () => {
  const current = running();
  if (!current) return; // dev server: no hashed bundle
  try {
    const res = await fetch('/index.html', { cache: 'no-store' });
    const published = bundleOf(await res.text());
    if (!published || published === current) return;
    if (sessionStorage.getItem('rv_updated_to') === published) return; // already reloaded once for this version
    sessionStorage.setItem('rv_updated_to', published);
    window.location.reload();
  } catch (e) { /* offline: try again next time */ }
};

export const startAutoUpdate = () => {
  check();
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') check(); });
};
